var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 31,
    viewBox: "0 0 23 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5338 1.03516C5.8641 1.03516 1.26709 5.73639 1.26709 11.5346C1.26709 15.7677 2.70924 16.95 10.4804 28.4704C10.99 29.2234 12.0797 29.2234 12.5893 28.4704C20.3567 16.9484 21.8004 15.7672 21.8004 11.5346C21.8004 5.73639 17.2018 1.03516 11.5338 1.03516ZM11.5338 15.8601C9.17403 15.8601 7.25598 13.8981 7.25598 11.4854C7.25598 9.07269 9.17563 7.11061 11.5338 7.11061C13.8919 7.11061 15.8115 9.07269 15.8115 11.4854C15.8115 13.8981 13.8919 15.8601 11.5338 15.8601Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.06753f08de731e6b8fbd1681b7c1f0b6.svg";
export { ForwardRef as ReactComponent };